import React from "react";
import { Users } from "lucide-react";
import Tooltip from "./Tooltip";

interface SharedListMarkProps {
  size?: number;
  className?: string;
}

/**
 * The one mark for "this list is shared" (#286), used everywhere a List
 * shows up: the board column, Settings, the List picker, the filter row's
 * list chooser, and a task card's list name. Uses the app's one accent
 * token (warm-blue / --color-primary) at low opacity, the same choice iOS
 * made for its own SharedListMark rather than introducing a second color.
 */
const SharedListMark: React.FC<SharedListMarkProps> = ({
  size = 12,
  className = "text-warm-blue",
}) => (
  <Tooltip content="Shared list">
    <span
      className={`inline-flex items-center flex-shrink-0 ${className}`}
      aria-label="Shared list"
    >
      <Users size={size} aria-hidden="true" />
    </span>
  </Tooltip>
);

export default SharedListMark;
